const BTN_NO_FILES_SELECTED_SINGULAR = 'Välj fil';
const BTN_FILES_SELECTED_SINGULAR = 'Välj fil';

let BTN_NO_FILES_SELECTED = '';
let BTN_FILES_SELECTED = '';

const LABEL_NO_FILES_SELECTED = 'Ingen fil vald';

let button;
let label;

function filesChanged(e) {
    let btnText = BTN_NO_FILES_SELECTED;
    let labelText = LABEL_NO_FILES_SELECTED;
    try {
        const files = e.currentTarget.files;
        if (files.length > 0) {
            labelText = Array.map(files, function(i){ return i.name }).join(', ');
        }
    } catch (error) { // >= ie9 where js file handling is not yet implemented
        if (e.currentTarget.value != "") {
            labelText = e.currentTarget.value.replace('C:\\fakepath\\', '');
        }
    }

    if (labelText !== LABEL_NO_FILES_SELECTED) {
        btnText = BTN_FILES_SELECTED;
        label.classList.remove('empty');
    }
    else
        label.classList.add('empty');

    button.innerText = btnText;
    label.innerText = labelText;
}

function addListeners() {
    var wrapper = document.querySelector('.custom-file-upload-wrapper');

    if (wrapper) {
        const fileInput = wrapper.querySelector('input');

        button = wrapper.querySelector('button');
        label = wrapper.querySelector('span');

        BTN_NO_FILES_SELECTED = BTN_NO_FILES_SELECTED_SINGULAR;
        BTN_FILES_SELECTED = BTN_FILES_SELECTED_SINGULAR;

        button.innerText = BTN_NO_FILES_SELECTED;
        label.classList.add('empty');

        fileInput.addEventListener('change', filesChanged);
    }
}

export default function fileInputHelper() {
    document.addEventListener('DOMContentLoaded', addListeners);
}